import { generateUUID, getButtonActionId, getTemporaryBlockId, processChangeCard, processCopyCard, processDeleteCard } from "../../../../../../../services/helpers/Helper";
import SlateEditor from "../../../../SlateEditor/editor";
import Action from "./action";
import Button from "./button";

const Text = (props) => {
   const { onSelect, onChange, faqId } = props;
   let { data, card } = props;

   const onChangeTitle = (string) => {
      if (onChange) {
         if (getTemporaryBlockId(data.first_block) === faqId) {
            data.first_block.cards = data.first_block.cards.map((m) => getTemporaryBlockId(m) === getTemporaryBlockId(card) ? { ...card, title: string } : m)
         }
         data.blocks = data.blocks.map(m => {
            if (getTemporaryBlockId(m) === faqId) {
               m.cards = m.cards.map((m2) => getTemporaryBlockId(m2) === getTemporaryBlockId(card) ? { ...card, title: string } : m2)
            }
            return m;
         });

         onChange(data);
      }
   }

   const handleAddButton = () => {
      if (onChange) {
         if (getTemporaryBlockId(data.first_block) === faqId) {
            data.first_block.cards = data.first_block.cards.map((m) => {
               return getTemporaryBlockId(m) === getTemporaryBlockId(card) ? { ...card, buttons: [...card.buttons, { title: 'Nút #' + (card.buttons.length + 1) }] } : m
            })
         }
         data.blocks = data.blocks.map(m => {
            if (getTemporaryBlockId(m) === faqId) {
               m.cards = m.cards.map(m2 => {
                  return getTemporaryBlockId(m2) === getTemporaryBlockId(card) ? { ...card, buttons: [...card.buttons, { title: 'Nút #' + (card.buttons.length + 1) }] } : m2
               })
            }
            return m;
         });
         onChange(data);
      }
   }

   const handleDelete = () => {
      if (onChange) {
         data = processDeleteCard(data, card, faqId);
         onChange(data);
      }
   }

   const handleCopy = () => {
      if (onChange) {
         delete card.id;
         card = {
            ...card,
            temporary_block_id: generateUUID()
         }
         if (getTemporaryBlockId(data.first_block) === faqId) {
            data.first_block.cards = [...data.first_block.cards, card];
         }
         data.blocks = data.blocks.map(m => {
            if (getTemporaryBlockId(m) === faqId) {
               m.cards = [...m.cards, card];
            }
            return m;
         });
         onChange(data);
      }
   }

   const handleChangeButton = (buttons) => {
      if (onChange) {
         data = processChangeCard(data, { ...card, buttons }, faqId);
         onChange(data);
      }
   }

   return (
      <nav>
         <div className="card-editor fadeInDown animated">
            <div className="card-item card-item-text">
               <div className="input-text input-text-none-scrollbar text-multi editor">
                  <SlateEditor
                     emoji={true}
                     control={true}
                     valueDefault={card.title}
                     onChange={onChangeTitle}
                     maxLength={640}
                  />
               </div>
               {card?.buttons?.map((button, index) => (
                  <Button
                     {...props}
                     button={button}
                     buttons={card?.buttons}
                     key={index}
                     index={index}
                     onSelect={onSelect}
                     handleChangeButton={handleChangeButton} />
               ))}
               {card?.buttons?.length < 3 &&
                  <div className="button-editor" onClick={handleAddButton}>
                     <span className="pointer text-ellipsis add-more text-center">
                        <div className="button-editor-wrapper">
                           <span className="button-content">
                              <span className="">+ Thêm nút</span>
                           </span>
                        </div>
                     </span>
                  </div>
               }
            </div>
            <Action
               onDelete={handleDelete}
               onCopy={handleCopy}
            />
         </div>
      </nav>
   )
}

export default Text;